require("./bootstrap");
require("alpinejs");
global.$ = global.jQuery = require("jquery");
window.$ = window.jQuery = require("jquery");

import { gsap } from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";

// Ensure GSAP and ScrollTrigger are loaded and configured
gsap.registerPlugin(ScrollTrigger);

// Select the header element
const header = document.querySelector(".header-new");

// Function to check and toggle the active class based on scroll position
const checkHeaderClass = () => {
    const sections = gsap.utils.toArray(".white-header");
    let isActive = false;

    sections.forEach(section => {
        const rect = section.getBoundingClientRect();
        if (rect.top <= 66 && rect.bottom >= 66) {
            isActive = true;
        }
    });

    if (isActive) {
        header.classList.add("active");
        if (header.classList.contains("white-at-start")) {
            header.classList.remove("white-at-start");
        }
    } else {
        header.classList.remove("active");
    }
};

// Check on load
window.addEventListener("load", checkHeaderClass);

// Check on scroll
window.addEventListener("scroll", checkHeaderClass);

// Iterate over each section and create a ScrollTrigger
gsap.utils.toArray(".white-header").forEach(section => {
    ScrollTrigger.create({
        trigger: section,
        start: "top-=66 top", // Adjusted to trigger when the header starts to overlap
        end: "bottom top+=66", // Adjusted to trigger when the header stops overlapping
        onEnter: checkHeaderClass, // Check class when entering a section
        onEnterBack: checkHeaderClass, // Check class when entering back a section
        onLeave: checkHeaderClass, // Check class when leaving a section
        onLeaveBack: checkHeaderClass, // Check class when leaving back a section
        markers: false // For debugging, remove in production
    });
});
